<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "app"
};
</script>

<style lang="scss">
// CoreUI Icons Set
@import "~@coreui/icons/css/coreui-icons.min.css";
/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome.scss";
/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/scss/simple-line-icons.scss";
/* Import Flag Icons Set */
@import "~flag-icon-css/css/flag-icon.min.css";
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
@import "assets/scss/style";

.w-5 {
  width: 5% !important;
}
.w-10 {
  width: 10% !important;
}
.btn-xs button {
  padding: 0px !important;
  font-size: 0.7rem;
}
// .vs__search::placeholder,
// .vs__dropdown-toggle,
// .vs__dropdown-menu {
//   min-height: calc(1.5em + 0.75rem + 2px);
//   font-size: 0.6rem;
//   font-weight: 400;
//   color: #5c6873;
//   border: none;
//   margin-top: -7px;
//   margin-left: 0px;
//   display: none;
// }
// .vs__clear,
// .vs__open-indicator {
//   fill: #394066;
//   display: none;
// }
</style>
